import type { MouseEventHandler } from 'react';
import React, { useState } from 'react';
import T from 'i18n-react';
import type { LinkProps } from 'next/link';
import Link from 'next/link';

import { Button } from '@motorway/mw-highway-code';
import type { ButtonProps } from '@motorway/mw-highway-code/src/components/Button/Button.types';

import texts from 'Components/texts.json';

T.setTexts(texts);

type LinkButtonProps = ButtonProps<typeof Link> & {
	as?: LinkProps['as'];
	className?: string;
	disableAfterClick?: boolean;
	label: string;
};

const LinkButton: React.FC<LinkButtonProps> = ({
	as,
	disableAfterClick = false,
	disabled,
	href,
	label,
	onClick,
	...rest
}) => {
	const [isLoading, setIsLoading] = useState(false);

	const handleButtonClick: MouseEventHandler<HTMLAnchorElement> = (e) => {
		if (isLoading) {
			e.preventDefault();
			return;
		}

		setIsLoading(disableAfterClick);
		onClick?.(e);
	};

	return (
		<Link legacyBehavior passHref as={as} href={href}>
			<Button
				as="a"
				disabled={disabled}
				label={label ? T.translate(label) : ''}
				loading={isLoading}
				onClick={handleButtonClick}
				{...rest}
			/>
		</Link>
	);
};

export default LinkButton;
